import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import ReactInk from "react-ink";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import { toggleBodyFixed } from "../helpers";

import * as HeroActions from "./HeroActions";

import "./Style";

class ShareViaEmailPortal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      errorInfo: null,
      mailBlockVisible: false,
      // toastId: null,
      emailRegex:
        /^$|^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      emailData: {
        emails: [],
        fullname: "",
        unbranded: false,
        emailHasError: false,
        fullnameHasError: false,
        message: "",
        messageHasError: false,
        ownEmail: "",
        ownEmailHasError: false,
      },
    };

    this.mobileMenuWrapperClick = this.mobileMenuWrapperClick.bind(this);
    this.windowKeyDown = this.windowKeyDown.bind(this);
    this.emailChange = this.emailChange.bind(this);
    this.emailValidationReject = this.emailValidationReject.bind(this);
    this.sendEmailSubmit = this.sendEmailSubmit.bind(this);
    this.inputChange = this.inputChange.bind(this);
  }

  componentDidMount = () => {
    window.addEventListener("keydown", this.windowKeyDown, false);
    window.addEventListener("click", this.mobileMenuWrapperClick, false);
    window.addEventListener("touchstart", this.mobileMenuWrapperClick, false);
    toggleBodyFixed();
  };

  componentWillUnmount = () => {
    window.removeEventListener("keydown", this.windowKeyDown, false);
    window.removeEventListener("click", this.mobileMenuWrapperClick, false);
    window.removeEventListener(
      "touchstart",
      this.mobileMenuWrapperClick,
      false
    );
    toggleBodyFixed(false);
  };

  componentDidCatch(error, errorInfo) {
    this.setState(
      {
        error,
        errorInfo,
      },
      () => {
        console.error(error, errorInfo);
      }
    );
  }

  windowKeyDown(e) {
    if (e.code.toLowerCase() === "escape" && this.props.isOpened) {
      this.props.btnClick(false);
    }
  }

  mobileMenuWrapperClick(e) {
    if (e.target.classList.contains("portal-menu")) {
      this.props.btnClick(false);
    }
  }

  emailChange(emails) {
    this.setState({
      emailData: {
        ...this.state.emailData,
        emailHasError: false,
        emails,
      },
    });
  }

  emailValidationReject() {
    this.setState({
      emailData: {
        ...this.state.emailData,
        emailHasError: true,
      },
    });
  }

  inputChange(e) {
    this.setState({
      emailData: {
        ...this.state.emailData,
        [e.target.name]: e.target.value,
        [e.target.name + "HasError"]: false,
      },
    });
  }

  sendEmailSubmit(e) {
    e.stopPropagation();
    e.preventDefault();

    const { emails, fullname, message, ownEmail } = this.state.emailData;

    const fullnameHasError = !fullname.trim().length;
    const messageHasError = !message.trim().length;
    const emailHasError = !emails.length;
    const ownEmailHasError =
      !ownEmail.trim().length || !this.state.emailRegex.test(ownEmail);

    //save errors to this.state
    this.setState(
      {
        emailData: {
          ...this.state.emailData,
          emailHasError,
          fullnameHasError,
          messageHasError,
          ownEmailHasError,
        },
      },
      () => {
        //in callback check if no errors then send data to API
        const {
          fullnameHasError,
          messageHasError,
          emailHasError,
          ownEmailHasError,
          emails,
          ownEmail,
          fullname,
          message,
          unbranded,
        } = this.state.emailData;

        if (
          !ownEmailHasError &&
          !emailHasError &&
          !fullnameHasError &&
          !messageHasError
        ) {
          grecaptcha.ready(() => {
            const sitekey = this.props.reCaptcha_key; // Google reCaptcha key from Tour data (see screenshot above)
            grecaptcha.execute(sitekey, { action: 'homepage' }).then((token) => {
                this.props.heroActions.sendEmail(emails,fullname,ownEmail,message,unbranded,token);
              });
          });
          this.props.btnClick(false);
          if (!toast.isActive(this.state.toastId)) {
            this.setState({
              toastId: toast.success("Mail has been sent."),
            });
          }
        }
      }
    );
  }

  render() {
    const { btnClick, isOpened } = this.props;
    const {
      ownEmailHasError,
      emailHasError,
      fullnameHasError,
      messageHasError,
    } = this.state.emailData;

    const menuClass = isOpened ? "portal-menu open" : "portal-menu";

    return ReactDOM.createPortal(
      <div className={menuClass}>
        <div className="portal-menu-body">
          <div className="portal-menu-header">
            <span>Share via email</span>
            <button
              className="btn btn-transparent"
              onClick={() => {
                btnClick(false);
              }}
            >
              <ReactInk />
              <i className="close-icon"></i>
            </button>
          </div>
          <form className="mail-content" onSubmit={this.sendEmailSubmit}>
            <div
              className={emailHasError ? "form-group has-error" : "form-group"}
            >
              <label htmlFor="email">Friend Email(s)</label>
              <TagsInput
                value={this.state.emailData.emails}
                onChange={this.emailChange}
                addOnBlur={true}
                className="email-tags"
                inputProps={{
                  className: "react-tagsinput-input",
                  placeholder: "Add an Email",
                }}
                addKeys={[32, 188]}
                onValidationReject={this.emailValidationReject}
                validationRegex={this.state.emailRegex}
              />
            </div>
            <div
              className={
                fullnameHasError ? "form-group has-error" : "form-group"
              }
            >
              <label htmlFor="fullname">Your Full Name</label>
              <input
                name="fullname"
                id="fullname"
                type="text"
                onChange={this.inputChange}
              />
            </div>
            <div
              className={
                ownEmailHasError ? "form-group has-error" : "form-group"
              }
            >
              <label htmlFor="ownEmail">Your Email Address</label>
              <input
                name="ownEmail"
                id="ownEmail"
                type="text"
                onChange={this.inputChange}
              />
            </div>
            <div
              className={
                messageHasError ? "form-group has-error" : "form-group"
              }
            >
              <label htmlFor="message">Add a personal message</label>
              <textarea
                name="message"
                id="message"
                cols="30"
                rows="5"
                onChange={this.inputChange}
              ></textarea>
            </div>
            <div className="form-group">
              <button type="submit" className="btn">
                <ReactInk />
                Send
              </button>
            </div>
          </form>
        </div>
      </div>,
      document.getElementById("portals")
    );
  }
}

ShareViaEmailPortal.propTypes = {};

const mapStateToProps = (state) => {
  return {
    reCaptcha_key: state.app.reCaptcha_key,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    heroActions: bindActionCreators(HeroActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShareViaEmailPortal);
